import { gql } from '@apollo/client';

export default gql`
  query AllWorkspaceGroup($workspaceId: Int!) {
    allParentProducers(condition: {parentProducerId: $workspaceId}) {
      nodes {
        id
        groupName
      }
      totalCount
    }
  }
`;
